<template>
  <div
    v-if="enableGooglePlaceAutocomplete"
    class="google-search"
  >
    <span class="google-search__label">{{fieldData.label}}</span>
    <div
      class="stripe-card__row stripe-card__row-two-col"
      :class="isDisabledField ? 'gmp-disabled' : ''"
    >
      <gmp-place-autocomplete
        :id="`place-autocomplete-element-${elementId}`"
      ></gmp-place-autocomplete>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import googlePlaceAutocompleteMixin from '@core/mixins/googlePlaceAutocompleteMixin.js'
import uniqueId from 'lodash/uniqueId'

export default {
  mixins: [googlePlaceAutocompleteMixin],
  props: {
    isDisabledField: {
      type: Boolean,
      default: false
    },
    fieldData: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      elementId: uniqueId(),
    }
  },
  mounted() {
    if (this.enableGooglePlaceAutocomplete) {
      this.loadGoogleMapsAPI()
        .then(() => {
          this.$nextTick(() => {
            const elementId = `place-autocomplete-element-${this.elementId}`
            this.attachPlaceSelectListener(this.handlePlaceSelect, elementId)
          })
        })
        .catch(error => {
          console.error('Error initial Google Maps:', error)
        })
    }
  },
  computed: {
    ...mapGetters({
      authSettings: 'authSettings/getAuthSettings',
    }),
    enableGooglePlaceAutocomplete() {
      return this.authSettings.google_services?.places_autocomplete ?? false
    },
  },
  methods: {
    handlePlaceSelect(event) {
      const placePrediction = event.placePrediction

      if (placePrediction) {
        const place = placePrediction.toPlace()

        this.fetchPlaceDetails(place).then(() => {
          this.setPlaceDetails()
        })
      }
    },
    async setPlaceDetails() {
      this.$emit('updateValue', { formattedAddress: this.googleFormattedAddress, placeId: this.googlePlaceID })

      const mapping = this.fieldData.settings.addressMapping

      Object.entries(this.googleAddressDetails).forEach(([key, value]) => {
        const mappedFieldId = mapping[key]

        if (!mappedFieldId) return

        if (this.fieldData.step_id) {
          this.$store.commit('applicationRegistration/UPDATE_RELATED_VALUE', {
            fromStepId: this.fieldData.step_id,
            updatedFieldId: mappedFieldId,
            value,
          })
          return
        }

        if (this.fieldData.pre_reg_form_id) {
          this.$store.commit('preRegistrationForm/UPDATE_RELATED_VALUE_IN_PRE_REG_FORM', {
            preRegFormId: this.fieldData.pre_reg_form_id,
            updatedFieldId: mappedFieldId,
            value,
          })
          return
        }

        if (this.type === 'registration_form') {
          this.$store.commit('registration/UPDATE_RELATED_VALUE_FORM', {
            updatedFieldId: mappedFieldId,
            value,
          })
          return
        }

        this.$store.commit('applicationRegistration/UPDATE_RELATED_VALUE_IN_FAMILY_FORM', {
          updatedFieldId: mappedFieldId,
          value,
        })
      })
    },
  },
}
</script>

<style lang="scss">

gmp-place-autocomplete {
  background-color: #EDEDED;
  color-scheme: light;
  border: none !important;
  padding: 0;
}
.gmp-disabled {
  pointer-events: none;
  opacity: 0.6;
  cursor: not-allowed;
}
</style>